import { render, staticRenderFns } from "./card-faq-delete-info.vue?vue&type=template&id=591aef46&scoped=true&"
import script from "./card-faq-delete-info.vue?vue&type=script&lang=js&"
export * from "./card-faq-delete-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591aef46",
  null
  
)

export default component.exports